import { api } from "./http";
import type { User } from "./types";

export const authApi = {
  me: () => api<{ user: User }>("/api/me").then((r) => r.user),
  requestOtp: (email: string) =>
    api<{ resendAvailableAt: string }>("/api/auth/otp/request", { method: "POST", json: { email } }),
  verifyOtp: (email: string, code: string, signal?: AbortSignal) =>
    api<{ user: User }>("/api/auth/otp/verify", {
      method: "POST",
      json: { email, code },
      ...(signal ? { signal } : {}),
    }),
  logout: () => api<void>("/api/auth/logout", { method: "POST" }),
  /** Закрывает вход и все сессии; данные администратор стирает в течение 30 дней. */
  /** null — человек ещё не согласился на обработку запросов внешней моделью ИИ. */
  aiConsent: () => api<{ aiConsentAt: string | null }>("/api/me").then((r) => r.aiConsentAt ?? null),
  acceptAiConsent: () => api<{ aiConsentAt: string }>("/api/account/ai-consent", { method: "POST" }),
  deleteAccount: () => api<void>("/api/account/delete", { method: "POST" }),
};

/** Устройство, где выполнен вход (сессия). */
export type AuthSession = { id: string; current: boolean; createdAt: string; lastSeenAt: string; userAgent: string | null; ip: string | null };

export const sessionsApi = {
  list: () => api<{ sessions: AuthSession[] }>("/api/auth/sessions").then((r) => r.sessions),
  end: (id: string) => api<void>(`/api/auth/sessions/${id}`, { method: "DELETE" }),
  endOthers: () => api<void>("/api/auth/logout-others", { method: "POST" }),
};
